module.exports = __webpack_public_path__ + "static/media/42.8903b60b.wav";